jQuery(document).ready(function($){
  $('#ContactForm').submit(function(e){
    e.preventDefault();

    var $form = jQuery(this);
    var $formData = $form.serialize();
    var emailData = {
      'FNAME' : $('#fit-fname').val(),
      'LNAME' : '',
      'EMAIL' : $('#fit-email').val()
    };
    $('#mce-FNAME').val(emailData.FNAME);
    $('#mce-EMAIL').val(emailData.EMAIL);

    if($('#ml').is(':checked')) {

      $('.submit-mce').trigger('click');
      
    } else {
   		$('#ContactForm')[0].submit();   
    }
  });
  $('#mce-form').ajaxChimp({
    url: $(this).attr('action'),
    callback: function(resp) {

      $('#ContactForm')[0].submit();   
    }
  });

	//First time pop up
	var cookieValue = jQuery.cookie("show_popup");
	if( cookieValue == '' || cookieValue != 'no' ) {
	    setTimeout(function () {
	        jQuery('.custom-popup').modal('show');
	        jQuery.cookie("show_popup", 'no', { expires : 10, path : '/' });
	    }, 10000);
	}

	//for closing the header search popup
	$('body').on('click', '.close-btn', function(event) {
		$('.search-top').removeClass('open');
	});

	$('body').on('click', '.subscription-form-submit', function(event) {
	    $('.subs-loader').show();
	    setInterval(function () {
	        if( $('#mce-error-response').css('display') == "block" ){
	        	$('.subs-loader').hide();
	        }
	        if( $('#mce-success-response').css('display') == "block" ){
	        	$('.subs-loader').hide();
	        }
	        if( $('form .mce_inline_error').length > 0 ){
	        	$('.subs-loader').hide();
	        }
	    }, 300);
	});

});

jQuery(document).ready(function($){
    var is_next_available = $(".main-pagination  ul li a.next").length;
    
    if(!is_next_available){
        $('.view-more-pagination').hide();
    }
     function load_more_posts_from_ajax() {
        var is_next_available = $(".main-pagination ul li a.next").length;
        console.log(is_next_available);
        if(is_next_available) {
            var getPagination = $(".main-pagination ul li a.next").attr('href');
            $.ajax({
                url: getPagination,
                type: "GET",
                dataType: "html"
            }).done(function(response) {
                $('.loader-img').hide();
                $('.view-more').show();
                var source = $('' + response + '');
                var divToFind = source.find('.blog-list-view').html();
                $('.blog-list-view').append(divToFind);
                var divPagination = source.find('.pagination').html();
                console.log(divPagination);
                var is_next_available = source.find('.main-pagination ul li a.next').length;
                console.log("Next link:"+is_next_available);
                if(!is_next_available){
                    $('.view-more-pagination').hide();
                }
                $('.pagination').html(divPagination);
             }).fail(function(jqXHR, textStatus, errorThrown) {
                console.log("Error in pagination");
             });
        }
    }
    $('body').on('click', '.view-more-pagination', function(event) {
        $('.view-more').hide();
        $('.loader-img').show();
        load_more_posts_from_ajax();
    });
  
  /* Header */
	if ( jQuery().isotope ) {          
		var jQuerycontainer = jQuery('.build-portfolio');
		jQuerycontainer.imagesLoaded(function(){
			jQuerycontainer.isotope({
				itemSelector: '.items',
				transitionDuration: '1s',
				percentPosition: true,               
				masonry: {
					columnWidth: '.grid-sizer'
				}
			});
		});            
	}
	$('body').on('click', '.action-links .search', function(event) {
		$('.action-links').hide();
		$('.search-wrap').show();
	});
	$('body').on('click','.categories-text h4',function(){
		$('.categories-text').toggleClass('open');
	});
	$('body').on('click', '.mini-cart-wrap a', function(event) {
		$('.mini-cart').toggle();
	});
	$('body').on('click', '.has-dropdown, .mega-menu', function(event) {
		$(this).toggleClass('open');
	});
	$('body').on('click', '.menu-toggle', function(event) {
		$(this).toggleClass('open');
		$('.nav-menu').toggleClass('d-flex');
	});
	$('body').on('click', '.top-close', function(event) {
		$('#header-text-banner').hide();
	});
	$('body').on('click', '.search-form', function(event) {
		$('.search-top').toggleClass('open');
	});

	$('body').on('click', '.leave-comment', function(event) {
		$('.comment-box').toggle();
	});

	header = $('.section-header').height();
	function sticky() {
		// $('body').css("padding-top", header);
	}
	sticky();
	$(window).resize(function(event) {
		header = $('.section-header').height();
		sticky();
	});
	$(window).scroll(function () {
	  // if ( $(this).scrollTop() > 100 && !$('header').hasClass('sticky') ) {
	  //   $('header').addClass('sticky');
	  //  } else if ( $(this).scrollTop() <= 100 ) {
	  //   $('header').removeClass('sticky');
	  // }
	});

	$(window).scroll(function(){
		setTimeout(function() { 
			if($('.portfolio-container').length >= 1) {
				toScroll = $('.portfolio-container').offset().top;
				if ( $(this).scrollTop() > toScroll ) {
					$('.loading-styles').show();
					$('.hide-product:lt(8)').removeClass('hide-product');
					console.log(toScroll);
					if ( jQuery().isotope ) {          
						var jQuerycontainer = jQuery('.build-portfolio');
						jQuerycontainer.imagesLoaded(function(){
							jQuerycontainer.isotope({
								itemSelector: '.items',
								transitionDuration: '1s',
								percentPosition: true,               
								masonry: {
									columnWidth: '.grid-sizer'
								}
							});
						});            
						
					}
				}
			}
		}, 1000);
      $('.loading-styles').hide();
	});

	
	/* Triangle remove class end */
	jQuery('img.svg').each(function(){
		var $img = jQuery(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		jQuery.get(imgURL, function(data) {
	            // Get the SVG tag, ignore the rest
	            var $svg = jQuery(data).find('svg');

	            // Add replaced image's ID to the new SVG
	            if(typeof imgID !== 'undefined') {
	            	$svg = $svg.attr('id', imgID);
	            }
	            // Add replaced image's classes to the new SVG
	            if(typeof imgClass !== 'undefined') {
	            	$svg = $svg.attr('class', imgClass+' replaced-svg');
	            }

	            // Remove any invalid XML tags as per http://validator.w3.org
	            $svg = $svg.removeAttr('xmlns:a');

	            // Check if the viewport is set, else we gonna set it if we can.
	            if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	            	$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	            }

	            // Replace image with new SVG
	            $img.replaceWith($svg);

	        }, 'xml');
    });	
  
    custom_matchheight();
  setTimeout(function(){
    $(window).trigger('resize');
  }, 2000);	
  $(window).resize(function(){      
      custom_matchheight();
    });
	$(".regular").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: true,
		asNavFor: '.variable'
	});
	$(".variable").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.regular',
		arrows: false,
		dots: false,
		centerMode: false,
		focusOnSelect: true
	}); 
	$(".glow-main-content-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.regular',
		arrows: false,
		dots: false,
		centerMode: false,
		focusOnSelect: true
	});
//   	function productReviewSlider() {
//       if($(window).width() <= 767) {
//         if(!$('.review-slider-product').hasClass('slick-initialized')) {
//           $('.review-slider-product').slick({
//               slidesToShow: 1,
//               slidesToScroll: 1,
//               arrows: false,
//               autoScroll: true,
//               adaptiveHeight: true
            
//           });
//         }
//       } else {
//         if($('.review-slider-product').hasClass('slick-initialized')) {
//           $('.review-slider-product').slick('unslick');
//         }
//       }
//     } 
//     $(window).resize(function(){
//       productReviewSlider();
//     });
//   	productReviewSlider();
	// $('.glow-main-content-slider').slick({
	// 	dots: true,
	// 	infinite: false,
	// 	speed: 300,
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	responsive: [
	// 	{
	// 		breakpoint: 1024,
	// 		settings: {
	// 			slidesToShow: 2,
	// 			slidesToScroll: 2,
	// 			infinite: true,
	// 			dots: true
	// 		}
	// 	},
	// 	{
	// 		breakpoint: 600,
	// 		settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1
	// 		}
	// 	}
	// 	// You can unslick at a given breakpoint now by adding:
	// 	// settings: "unslick"
	// 	// instead of a settings object
	// 	]
	// });
  function custom_matchheight() {
    $('.matchHeight').matchHeight({
      byRow: true
    });

    $('.content-text-height').matchHeight({
      byRow: true
    });
    $('.text-height').matchHeight({
      byRow: true
    });
  }
  
  $(".site-nav--has-dropdown").hover(function(){
    $(this).find('.sub-menu').addClass('active');
  }, function(){
    $(this).find('.sub-menu').removeClass('active');
  });

});